<template>

  <div
    ref="introduction"
    data-name="introduction"
    :class="[$style.wrapper, {
      'hide-introduction': hasBeenRestarted,
    }]">
    <div
      ref="headerContainer"
      data-name="header-container"
      :class="$style['header-container']"
    >
      <div :class="$style['header-line1']"></div>
      <h1>{{ headerText }}</h1>
      <div :class="$style['header-line2']"></div>
    </div>

    <div
      data-name="introduction-content-container"
      :class="$style['introduction-content-container']"
      ref="introductionContentContainer"
    >
      <!-- <div :class="$style['house-image-container']"> HOUSE IMAGE </div> -->
      <div
        data-name="content-wrapper"
        :class="$style['content-wrapper']">
          <div
            ref="introTextContainer"
            data-name="intro-text-container"
            :class="$style['intro-text-container']"
          >
            <div :class="$style.intro">
              {{ introText }}
            </div>
          </div>

          <div :class="$style.buttons">
            <div
            ref="buttonContainer"
            data-name="button-container"
            :class="$style['button-container']"
          >
            <ui-button
              :buttonText="buttonText"
              :buttonAction="handleStartButtonClick"
              v-touch.native="handleStartButtonClick"
            ></ui-button>
          </div>

          <!-- <testimonial-button :class="$style['testimonial-button']" v-show="testimonial" ref="testimonialWrapper" :testimonial="testimonial" title="Click to show all testimonials" aria-label="Click to show all testimonials"></testimonial-button> -->
          </div>
      </div>

    </div>
  </div>

</template>

<script>
import UiButton from './UiButton';
import { TweenMax, TimelineMax } from 'gsap';
import isMobileMixin from '../plugins/isMobileMixin.js';
import tweenSpeedsMixin from '../plugins/tweenSpeedsMixin.js';
import TestimonialButton from './TestimonialButton.vue';
import axios from 'axios';

export default {
  name: 'introduction',
  mixins: [isMobileMixin, tweenSpeedsMixin],
  components: { UiButton, TestimonialButton },

  data() {
    return {
      headerText: '',
      introText: '',
      buttonText: '',
      testimonial: '',
      isFaded: true,
      // tweenSpeeds: {
      //   itemFadeIn: 1,
      //   staggerDiff: 0.2
      // },
      tl: null,
      elsToAnim: null
    };
  },
  computed: {
    appState: function() {
      return this.$store.getters.getAppState;
    },
    hasBeenRestarted: function() {
      return this.$store.getters.getHasBeenRestartedState;
    }
  },
  watch: {
    appState(state, oldState) {
      if (
        (state === 'introduction' || state === 'intro-anim') &&
        this.hasBeenRestarted
      ) {
        // TweenMax.set(this.$refs.introduction, {
        //   opacity: 0,
        //   pointerEvents: 'none',
        // });
        // seems to run twice if uncommented
        // this.fadeIntroductionIn();
      } else if (state === 'intro-anim') {
        this.fadeIntroductionOut();
      }
    }
  },
  beforeCreate() {
    axios.get('/static/info.json').then(response => {
      // probably not the best way
      // console.log('response:  ', response);
      this.headerText = response.data.introduction.header;
      this.introText = response.data.introduction.intro;
      this.buttonText = response.data.introduction.button;
      this.testimonial = response.data.testimonials[0];
    });
  },
  mounted() {
    this.tl = new TimelineMax({
      // paused: true,
    });

    this.elsToAnim = [
      this.$refs.headerContainer,
      this.$refs.introTextContainer,
      this.$refs.buttonContainer,
      this.$refs.introductionContentContainer
      // this.$refs.testimonialWrapper.$el
    ];

    TweenMax.set(this.elsToAnim, {
      opacity: 0,
      y: '10%',
      onComplete: this.fadeIntroductionIn
    });
  },
  methods: {
    handleStartButtonClick: function() {
      // debugger;
      this.fadeIntroductionOut();

      this.$store.dispatch('updateAppState', { state: 'intro-anim' });
      // this.$refs.PlaneAnim.StartIntroAnim();
    },
    fadeIntroductionIn() {
      if (this.hasBeenRestarted) {
        return;
      }

      TweenMax.staggerFromTo(
        this.elsToAnim,
        this.tweenSpeeds.dur.itemFadeIn,
        {
          opacity: 0
        },
        {
          opacity: 1,
          delay: 1.25,
          y: '0%',
          onComplete: () => {
            TweenMax.set(this.$refs.introduction, {
              pointerEvents: 'auto',
              zIndex: 300
            });
          },
          ease: this.tweenSpeeds.ease.global
        },
        this.tweenSpeeds.dur.staggerDiff
      );

      // TweenMax.set(this.$refs.introduction, {
      //   'pointerEvents': 'auto',
      // });
    },
    fadeIntroductionOut() {
      TweenMax.staggerFromTo(
        this.elsToAnim,
        this.tweenSpeeds.dur.itemFadeIn,
        {
          opacity: 1
        },
        {
          opacity: 0,
          onComplete: () => {
            TweenMax.set(this.$refs.introduction, {
              pointerEvents: 'none',
              zIndex: -1
            });
          }
        },
        this.tweenSpeeds.dur.staggerDiff
      );
    }
  }
};
</script>

<style lang='scss' module>
@import '../assets/css/globals.scss';

* {
  // outline: 1px solid red;
}

h1 {
  font-size: 22px;

  @include medium {
    font-size: 36px;
  }

  @include xxxlarge {
    font-size: 48px;
  }
}

.hide-introduction {
  opacity: 0;
  pointer-events: none;
}

.wrapper {
  z-index: 300;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  padding-top: 100px;

  color: $white;
  pointer-events: none;
  opacity: 1;

  @include xxxlarge {
    padding-top: 150px;
  }
}

.header-container {
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  margin-bottom: auto;

  height: 7%;
  width: 100%;

  text-align: center;

  z-index: 500;

  @include large {
    margin-bottom: 0;
    margin: auto;

    width: 60%;
  }
}

.header-line1,
.header-line2 {
  height: 2px;
  width: 10%;

  opacity: 0.7;

  background-color: rgba($white, 0.4);

  @include large {
    width: 13%;
  }
}

.header-line1 {
  // margin-right: auto;
  margin-right: 20px;
}

.header-line2 {
  // margin-left: auto;
  margin-left: 20px;
}

.intro-text-container {
  z-index: 500;
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
  line-height: 1.5;
  font-size: 14px;
  text-shadow: 0 0 5px rgba($black, 0.5);

  @include medium {
    width: calc(50% - 50px);
    align-items: flex-end;

    font-size: 18px;
    text-align: left;
    margin-bottom: 0;

    padding-left: 0px;
    padding-right: 0px;
  }

  @include xxxlarge {
    width: 75%;

    padding-left: 50px;
    padding-right: 190px;

    font-size: 24px;
  }
}

.intro {
  max-width: 285px;

  @include xxxlarge {
    max-width: none;
    // max-width: 500px;
    width: 100%;
  }
}

.buttons {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @include medium {
    width: calc(50% - 50px);
    align-items: flex-start;
  }
}

.button-container {
  width: 240px;
  height: 45px;

  margin-bottom: 24px;

  color: $white;

  z-index: 500;

  font-size: 13px;
  font-weight: bold;

  @include medium {
    width: 100%;
    max-width: 285px;
  }

  @include large {
    width: 285px;

    margin-bottom: 45px;

  }

  @include xxxlarge {
    width: 100%;
    // max-width: 500px;
  }
}

.testimonial-button {
  @include medium {
    width: 100%;
    max-width: 285px;
  }

  @include xxxlarge {
    max-width: 500px;
  }
}

.introduction-content-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;

  height: 93%;

  // @include large {
  //   flex-direction: row;
  // }

  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.5) 50%,
    rgba(255, 255, 255, 0) 100%
  );

  @include medium {
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(255, 255, 255, 0) 75%
    );
  }
}

.house-image-container {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 30%;
  width: 100%;

  // background-color: blue;

  @include large {
    // display: none;
  }
}

.content-wrapper {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;

  height: 70%;

  @include medium {
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 80px;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;

    height: 100%;
  }

  @include xxlarge {
    max-width: 1440px;
    padding-left: 100px;
    padding-right: 100px;
    padding-bottom: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Introduction.vue